<template lang="pug">

.app-card.tw-mb-5.invoiceables-styled-panel
  //- Header con título y contador
  .d-flex.align-items-center.justify-content-between.tw-mb-3.tw-pb-2.tw-border-b.tw-border-gray-200
    .d-flex.align-items-center.tw-gap-2
      .tw-w-10.tw-h-10.tw-rounded-lg.tw-bg-indigo-100.tw-flex.tw-items-center.tw-justify-center
        i.fa-solid.fa-list-check.tw-text-indigo-600.tw-text-lg
      div
        span.tw-font-semibold.tw-text-gray-700 Invoice Items
        span.tw-bg-indigo-100.tw-text-indigo-700.tw-px-2.tw-py-1.tw-rounded-full.tw-text-xs.tw-font-medium.tw-ml-2
          | {{ filteredItems.length }}
    edit-invoiceable-modal(
      :data-icon='"fa-solid fa-plus"' 
      :data-label="$I18n.t('vue.invoiceables_detail_table_panel.create_new_invoice_item')"
      :data-mode='"new"'
      :data-item='JSON.stringify(empty_item)'
      :data-percentage-default='dataPercentageDefault'
      @updated='createNewInvoiceItem'
    )
  
  //- Leyenda de columnas
  .tw-flex.tw-items-center.tw-gap-4.tw-mb-3.tw-text-xs(v-if='!emptyItems')
    span.tw-text-gray-500 Column Groups:
    .d-flex.align-items-center.tw-gap-1
      span.tw-w-3.tw-h-3.tw-rounded.tw-bg-gray-200
      span.tw-text-gray-600 Item Info
    .d-flex.align-items-center.tw-gap-1
      span.tw-w-3.tw-h-3.tw-rounded.tw-bg-green-200
      span.tw-text-gray-600 Pricing
  
  //- Tabla mejorada
  table(v-if='!emptyItems' class="table table-hover invoiceables-styled-table")
    thead.tw-bg-gray-50
      tr
        //- Grupo: Item Info
        th.tw-text-left.tw-bg-gray-100(style="border-left: 2px solid #e5e7eb;")
          .d-flex.align-items-center.tw-gap-1
            i.fa-solid.fa-tag.tw-text-gray-400.tw-text-xs
            span {{$I18n.t('vue.invoiceables_detail_table_panel.table_header_concept')}}
        th.tw-text-left.tw-bg-gray-100(style="border-right: 2px solid #e5e7eb;")
          .d-flex.align-items-center.tw-gap-1
            i.fa-solid.fa-align-left.tw-text-gray-400.tw-text-xs
            span {{$I18n.t('vue.invoiceables_detail_table_panel.table_header_description')}}
        //- Grupo: Pricing
        th.tw-text-right.tw-bg-green-50(style="border-left: 2px solid #bbf7d0;")
          .d-flex.align-items-center.tw-gap-1.justify-content-end
            i.fa-solid.fa-dollar-sign.tw-text-green-500.tw-text-xs
            span {{$I18n.t('vue.invoiceables_detail_table_panel.table_header_price')}}
        th.tw-text-center.tw-bg-green-50
          span {{$I18n.t('vue.invoiceables_detail_table_panel.table_header_quantity')}}
        th.tw-text-center.tw-bg-green-50
          .d-flex.align-items-center.tw-gap-1.justify-content-center
            i.fa-solid.fa-percent.tw-text-green-500.tw-text-xs
            span %
        th.tw-text-right.tw-bg-green-50(style="border-right: 2px solid #bbf7d0;")
          .d-flex.align-items-center.tw-gap-1.justify-content-end
            i.fa-solid.fa-calculator.tw-text-green-500.tw-text-xs
            span {{$I18n.t('vue.invoiceables_detail_table_panel.table_header_total')}}
        th.tw-text-center.tw-w-20 Actions
    tbody
      tr(v-for="item in filteredItems" :key="item.id" class="tw-transition-colors hover:tw-bg-indigo-50")
        //- Item info
        td.tw-bg-gray-50.tw-bg-opacity-30
          .d-flex.align-items-center.tw-gap-2
            .tw-w-6.tw-h-6.tw-rounded.tw-bg-indigo-100.tw-flex.tw-items-center.tw-justify-center.tw-flex-shrink-0
              i.fa-solid.fa-cube.tw-text-indigo-500.tw-text-xs
            span.tw-font-medium.tw-text-gray-800 {{item.concept}}
        td.tw-bg-gray-50.tw-bg-opacity-30
          span.tw-text-gray-600.tw-text-sm {{item.description || '—'}}
        //- Pricing group
        td.tw-text-right.tw-bg-green-50.tw-bg-opacity-50
          span.tw-text-gray-700 {{item.masked_price}}
        td.tw-text-center.tw-bg-green-50.tw-bg-opacity-50
          span.tw-inline-flex.tw-items-center.tw-justify-center.tw-w-6.tw-h-6.tw-bg-gray-100.tw-rounded.tw-text-xs.tw-font-medium {{item.quantity}}
        td.tw-text-center.tw-bg-green-50.tw-bg-opacity-50
          span.tw-text-gray-600.tw-text-sm {{item.masked_percentage}}
        td.tw-text-right.tw-bg-green-50.tw-bg-opacity-50
          span.tw-font-bold.tw-text-green-700 {{item.masked_total}}
        td.tw-text-center
          .app-buttons-row.justify-content-center.tw-gap-1
            delete-invoiceable-modal(
              :data-id='item.id'
              @deleted='deleteInvoiceItem'
            )
            edit-invoiceable-modal(
              :data-icon='"fa-solid fa-pencil"'
              :data-label='""'
              :data-mode='"edit"'
              :data-item='JSON.stringify(item)'
              :data-percentage-default='dataPercentageDefault'
              @updated='updateInvoiceItem'
            )
  
  //- Total
  .tw-flex.justify-content-end.tw-mt-3(v-if='!emptyItems')
    .tw-bg-green-50.tw-border.tw-border-green-200.tw-rounded-lg.tw-px-4.tw-py-2
      .d-flex.align-items-center.tw-gap-3
        span.tw-text-gray-600.tw-text-sm {{$I18n.t('vue.invoiceables_detail_table_panel.total_invoice_items')}}
        span.tw-font-bold.tw-text-green-700.tw-text-lg {{calcularTotal()}}

  //- Empty state
  .tw-text-center.tw-py-8(v-if='emptyItems')
    .tw-w-16.tw-h-16.tw-bg-indigo-100.tw-rounded-full.tw-flex.tw-items-center.tw-justify-center.tw-mx-auto.tw-mb-3
      i.fa-solid.fa-list-check.tw-text-indigo-400.tw-text-2xl
    p.tw-text-gray-500.tw-mb-0 {{$I18n.t('vue.invoiceables_detail_table_panel.empty_items')}}

</template>
<script>

import DeleteInvoiceableModal from './delete-invoiceable-modal.vue'
import EditInvoiceableModal from './edit-invoiceable-modal.vue'
import {BackendService} from '../../services';
import CoreComponents from '../core';

export default {
  components:{
    'delete-invoiceable-modal':DeleteInvoiceableModal,
    'edit-invoiceable-modal':EditInvoiceableModal,
    "app-icon-btn": CoreComponents.AppIconBtn,
  },
  props:{
    dataId: String,
    dataModel: String,
    dataItems: String,
    dataPercentageDefault: String,
  },
  data: function(){
    return {
      state: {
        confirmed: false,
      },
      empty_item:{
        concept:"",
        description:"",
        price:"",
        quantity:"",
        percentage:"",
        total:"",
      },
      record:{
        id: this.dataId,
      },
      items: JSON.parse(this.dataItems),
    }
  },
  computed:{
    emptyItems: function(){
      return this.filteredItems.length === 0;
    },
    filteredItems: function(){
      // Filtrar items que tengan precio mayor a 0
      return this.items.filter(item => {
        if (!item.masked_total) return false;
        // Remover caracteres de moneda y convertir a número
        const total = parseFloat(item.masked_total.toString().replace(/[$,\s]/g, ''));
        return total > 0;
      });
    }
  },
  methods:{
    retrieveInvoiceItems:function(){
      location.reload();
    },
    createNewInvoiceItem:function(item){
      const self = this;
      this.state.sending = true;
      let params = JSON.stringify({
        id: this.dataId,
        invoice_item: JSON.parse(item)
      })
      BackendService
        .create_invoice_item(params)
        .then((response) => {
          if (response.isOk) {
            location.reload();
          }
        })
        .catch(() => {
          self.result.isError = true;
          self.result.notice = "error_promise";
          self.state.sending = false;
        });
    },
    deleteInvoiceItem:function(invoiceable_id){
      const self = this;
      this.state.sending = true;
      BackendService
        .delete_invoice_item(invoiceable_id)
        .then((response) => {
          if (response.isOk) {
            location.reload();
          }
        })
        .catch(() => {
          self.result.isError = true;
          self.result.notice = "error_promise";
          self.state.sending = false;
        });
    },
    updateInvoiceItem:function(params){
      const self = this;
      this.state.sending = true;
      BackendService
        .update_invoice_item(params)
        .then((response) => {
          if (response.isOk) {
            location.reload();
          }
        })
        .catch(() => {
          self.result.isError = true;
          self.result.notice = "error_promise";
          self.state.sending = false;
        });
    },
    calcularTotal:function(){
      // Usamos reduce para iterar sobre el array filtrado y sumar los precios
      let total = this.filteredItems.reduce((total, item) => {
        return total + parseFloat(item.total.replace("$", "").replace(",", "").replace(" ", ""));
      }, 0); // Inicializamos el total en 0
      return total.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    }
  }
}
</script>

<style scoped>
.invoiceables-styled-panel {
  padding: 1rem;
}

.invoiceables-styled-table {
  font-size: 0.85rem;
}

.invoiceables-styled-table thead th {
  white-space: nowrap;
  vertical-align: middle;
  padding: 0.5rem 0.75rem;
  font-weight: 600;
  color: #4b5563;
  font-size: 0.8rem;
}

.invoiceables-styled-table tbody td {
  vertical-align: middle;
  padding: 0.5rem 0.6rem;
}

.tw-bg-opacity-30 {
  --tw-bg-opacity: 0.3;
}

.tw-bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}
</style>
